import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';


import { ApiError, MessageService } from '../../../../../core';
import { ClienteClassificacao } from '../cliente-classificacao';
import { GrupoClassificacaoClassificavelFormComponent } from '../../../../grupo-classificacao/classificavel/form';
import { GrupoClassificacao } from '../../../../grupo-classificacao';
import { GrupoClassificacaoClassificacao } from '../../../../grupo-classificacao/classificacao';
import { GrupoClassificacaoSituacaoHttpService } from '../../../../grupo-classificacao/situacao';

@Component({
    selector: 'sgt-cliente-classificacao-form',
    templateUrl: './cliente-classificacao-form.component.html',
    styleUrls: ['./cliente-classificacao-form.component.less']
})
export class ClienteClassificacaoFormComponent {
    /** Se pode editar as classificações do cliente */
    @Input() canEdit = false;
    /** ID do cliente */
    @Input() idCliente: number;

    /** Classificações do cliente */
    @Input() entities: ClienteClassificacao[];
    /** Ao alterar as classificações do cliente */
    @Output() entitiesChange = new EventEmitter<ClienteClassificacao[]>();

    @ViewChild('form') form: GrupoClassificacaoClassificavelFormComponent;

    constructor(private messageService: MessageService,
                private grupoClassificacaoSituacaoHttpService: GrupoClassificacaoSituacaoHttpService) { }

    /** Carrega o grupo de classificação de cadastro de clientes */
    private loadGrupoClassificacao(): Promise<GrupoClassificacao> {
        return new Promise<GrupoClassificacao>((resolve, reject) => {
            this.grupoClassificacaoSituacaoHttpService.loadCadastroCliente()
                .pipe(
                    take(1)
                )
                .subscribe(
                    grupoClassificacao => resolve(grupoClassificacao),
                    (error: ApiError) => reject(error)
                );
        });
    }

    /** Insere uma classificação no cliente através da classificação do grupo */
    private insertClassificacao(grupoClassificacaoClassificacao: GrupoClassificacaoClassificacao) {
        const entity = new ClienteClassificacao();
        entity.idCliente = this.idCliente;

        // Setando as informações do grupo de classificação na entidade
        this.form.insertClassificacao(entity, grupoClassificacaoClassificacao);

        this.entities.push(entity);
    }

    /** Insere classificações do grupo de classificação de cadastro de clientes no cliente */
    insert(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.loadGrupoClassificacao()
                .then(grupoClassificacao => {
                    if (grupoClassificacao) {
                        grupoClassificacao.classificacoes?.forEach(grupoClassificacaoClassificacao => this.insertClassificacao(grupoClassificacaoClassificacao));
                    } else {
                        this.entities = [];
                    }

                    this.entitiesChange.emit(this.entities);
                    resolve();
                })
                .catch((error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao adicionar os segmentos no novo cliente', error);
                    reject();
                });
        });
    }

    /** Verifica se as classificações estão válidas */
    isValid(): boolean {
        return this.form.isValid();
    }
}
